/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.thinkprocess.ThinkProcessStatus
*/
export var ThinkProcessStatus;
(function (ThinkProcessStatus) {
    ThinkProcessStatus["INIT"] = "INIT";
    ThinkProcessStatus["RUNNING"] = "RUNNING";
    ThinkProcessStatus["IDLE"] = "IDLE";
    ThinkProcessStatus["BLOCKED"] = "BLOCKED";
    ThinkProcessStatus["PAUSED"] = "PAUSED";
    ThinkProcessStatus["SUSPENDED"] = "SUSPENDED";
    ThinkProcessStatus["CLOSED"] = "CLOSED";
})(ThinkProcessStatus || (ThinkProcessStatus = {}));
//# sourceMappingURL=ThinkProcessStatus.js.map